/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAlertType } from './InternalApiAlertType';
import {
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeFromJSONTyped,
    InternalApiAlertTypeToJSON,
    InternalApiAlertTypeToJSONTyped,
} from './InternalApiAlertType';

/**
 * 
 * @export
 * @interface InternalApiUpdateAlertNoteTemplateRequest
 */
export interface InternalApiUpdateAlertNoteTemplateRequest {
    /**
     * 
     * @type {InternalApiAlertType}
     * @memberof InternalApiUpdateAlertNoteTemplateRequest
     */
    alertType: InternalApiAlertType;
    /**
     * 
     * @type {string}
     * @memberof InternalApiUpdateAlertNoteTemplateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiUpdateAlertNoteTemplateRequest
     */
    content: string;
}



/**
 * Check if a given object implements the InternalApiUpdateAlertNoteTemplateRequest interface.
 */
export function instanceOfInternalApiUpdateAlertNoteTemplateRequest(value: object): value is InternalApiUpdateAlertNoteTemplateRequest {
    if (!('alertType' in value) || value['alertType'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiUpdateAlertNoteTemplateRequestFromJSON(json: any): InternalApiUpdateAlertNoteTemplateRequest {
    return InternalApiUpdateAlertNoteTemplateRequestFromJSONTyped(json, false);
}

export function InternalApiUpdateAlertNoteTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiUpdateAlertNoteTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'alertType': InternalApiAlertTypeFromJSON(json['alertType']),
        'name': json['name'],
        'content': json['content'],
    };
}

export function InternalApiUpdateAlertNoteTemplateRequestToJSON(json: any): InternalApiUpdateAlertNoteTemplateRequest {
    return InternalApiUpdateAlertNoteTemplateRequestToJSONTyped(json, false);
}

export function InternalApiUpdateAlertNoteTemplateRequestToJSONTyped(value?: InternalApiUpdateAlertNoteTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alertType': InternalApiAlertTypeToJSON(value['alertType']),
        'name': value['name'],
        'content': value['content'],
    };
}

